import PropTypes from 'prop-types'
import React from 'react'
import InputLabel from '../ui/InputLabel'
import Select from '../ui/Select'

// eslint-disable-next-line no-unused-vars
const PrecioRango = React.forwardRef(({ values, unidades, onChange, onEliminar, id }, ref) => {
  const { cantidad, idUnidadMedida, precio } = values

  return (
    <div className="precio-form-grid precio-rango">
      <InputLabel
        type="number"
        name="cantidad"
        value={cantidad}
        onChange={(e) => onChange(e, id)}
        label="Cantidad:"
        classNameContainer="precio-campo"
        error="Completar Precio Mayorista Cantidad"
        onFocusSelected
      />

      <div className="precio-campo">
        <label htmlFor="idUnidadMedida">Unidad:</label>
        <div className="precio-campo-control">
          <Select
            name="idUnidadMedida"
            value={idUnidadMedida}
            onChange={(e) => onChange(e, 'num')}
            datos={unidades}
            optionMetaDatos={{ value: 'idUnidadMedida', text: 'nombre' }}
            optionPorDefecto={{ value: '0', text: 'Seleccionar' }}
            disabled={id > 0}
          />
        </div>
      </div>

      <InputLabel
        type="number"
        name="precio"
        value={precio}
        onChange={(e) => onChange(e, id)}
        label="Precio Unitario ($):"
        classNameContainer="precio-campo"
        error="Completar Precio Mayorista Unitario"
        onFocusSelected
      />

      {onEliminar && (
        <div className="precio-rango-acciones">
          <button
            type="button"
            className="precio-eliminar-rango-btn"
            onClick={onEliminar}
            aria-label="Eliminar rango de precio mayorista"
            title="Eliminar este rango"
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </div>
      )}
    </div>
  )
})

PrecioRango.displayName = 'PrecioRango'

PrecioRango.propTypes = {
  values: PropTypes.shape({
    cantidad: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    idUnidadMedida: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    precio: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
  }).isRequired,
  unidades: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  onEliminar: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
}

export default PrecioRango
